import { NumberInput, type NumberInputProps } from "@mantine/core";
import { useControlSize } from "../../theme/useControlSize";

/**
 * Numeric entry. Use this and never a plain text input for a quantity, a
 * weight or a count.
 *
 * Three things it guarantees, each of which has bitten somebody somewhere:
 *
 *  - `inputMode="decimal"` opens the NUMBER PAD on Android. A text keyboard
 *    for a quantity is a tap on "1" away from a letter.
 *  - no spinner arrows. On a phone they are useless, and beside a figure that
 *    ends up on a GST invoice a stray tap is a wrong number nobody notices.
 *  - tabular figures at weight 600, so a column of them lines up.
 *
 * Size comes from the viewport: 42px on a phone, 36px on desktop. A 36px
 * target is below what a thumb hits reliably, and these are filled in
 * one-handed at a customer's gate.
 */
export function NumField(props: NumberInputProps) {
  const size = useControlSize();
  return <NumberInput size={size} {...props} />;
}
